import React from 'react';

/** Tüm yönetim ekranlarında ortak kurumsal sayfa başlığı. */
export const PageHeader = ({ icon: Icon, title, description, actions, children, testid }) => (
  <div className="bg-white rounded-xl border border-[#E2E8F0] shadow-sm" data-testid={testid}>
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 md:px-5 py-4">
      <div className="flex items-center gap-3 min-w-0">
        {Icon && (
          <div className="rounded-xl bg-[#0B172A] text-white p-2.5 shrink-0">
            <Icon className="w-5 h-5" />
          </div>
        )}
        <div className="min-w-0">
          <h2 className="text-lg md:text-xl font-bold text-slate-900 tracking-tight truncate">{title}</h2>
          {description && <p className="text-[12px] md:text-sm text-slate-500 truncate">{description}</p>}
        </div>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
    {children && <div className="border-t border-[#E2E8F0] px-4 md:px-5 py-3">{children}</div>}
  </div>
);

export default PageHeader;
